import {useNavigate} from 'react-router-dom';
import Button from '../../../../components/button';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetListLoanRequest from '../../../../services/hookService/getListLoanRequest/useGetListLoanRequest';
import {
  LoanRequestStatus,
  showCancelButtonByLoanStatus,
} from '../../../myAccount/my-credits/consts/loanStatus';
import MultiStepComponent from '../MultiStepComponent';
import {receiveCreditSteps} from '../receiveCreditSteps';
import LoadingHourglass from '../step3-completeDocs/components/LoadingHourglass';
import LoanRequestHeader from '../step3-completeDocs/components/LoanRequestHeader';
import {useMultiStepForm} from '../useMultiStepForm';

const IsValidatingPage = () => {
  // ---------------- Cancel Loan States ----------------

  const navigate = useNavigate();

  const {data: listLoanRequest, isLoading: isLoadingListLoanRequest} =
    useGetListLoanRequest({is_finished: false});

  const {stepNumber} = useMultiStepForm();

  const isLoading = isLoadingListLoanRequest;

  const handleNextSection = () => {
    navigate('/my-account', {replace: true});
  };

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      {/* Header */}
      <LoanRequestHeader
        backPath="/my-credits"
        title="دریافت اعتبار"
        loanRequestGuid={listLoanRequest?.guid}
        showCancelButton={showCancelButtonByLoanStatus(
          listLoanRequest?.status as LoanRequestStatus,
        )}
      />
      {/* Content */}
      <div className="flex flex-col w-full h-full gap-3 p-3 overflow-y-auto">
        {isLoading && (
          <div className="grid h-dvh place-content-center">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && (
          <>
            <MultiStepComponent
              steps={receiveCreditSteps}
              currentStep={stepNumber}
            />

            <section className="flex flex-col gap-[1.5rem] mt-3 text-sm">
              <div>
                <span className="text-gray-600">
                  درخواست دریافت اعتبار شما ثبت شد و در حال بررسی است. نتیجه به
                  شما اعلام می‌شود.
                </span>
              </div>

              <LoadingHourglass className="mt-4" />

              <div className="fixed left-0 right-0 z-50 flex flex-col w-full gap-2 bottom-2 ">
                <div className="p-3">
                  <Button
                    type="button"
                    className="w-full"
                    onClick={handleNextSection}
                  >
                    متوجه شدم
                  </Button>
                </div>

                <MainFooter isScrolling={false} />
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default IsValidatingPage;
